import React from 'react';
import PageHero from '../components/PageHero';
import ACCELERATORS from '../data/accelerators';

export default function Accelerators() {
  return (
    <>
      <PageHero
        modifier="accelerators"
        kicker="Delivery Accelerators"
        title="Accelerators"
        desc="Reusable frameworks, starter kits and AI-assisted tools to reduce delivery time and improve quality on every engagement."
      />
      <section className="section section-soft">
        <div className="container grid grid-3 animate-cards">
          {ACCELERATORS.map((a, i) => (
            <div className="card card--accelerator" key={i}>
              <div className="card-tag">{a.tag}</div>
              <div className="icon-circle">{a.icon}</div>
              <span className="accel-stat">{a.stat}</span>
              <h3>{a.title}</h3>
              <p>{a.desc}</p>
              <ul>{a.items.map((item, j) => <li key={j}>{item}</li>)}</ul>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
